import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';

export interface DialogData {
  unit: string;
  factor: string;
  errorMessage?: string;
}

@Component({
  standalone: false,
  selector: 'app-add-unit-converter-dialog',
  templateUrl: 'add-unit-converter-dialog.component.html',
  styleUrls: ['add-unit-converter-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AddUnitConverterDialogComponent {
  errorMessage: string;
  onAddCallback: ((unit: string, factor: number) => void) | null = null;
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<AddUnitConverterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.errorMessage = data.errorMessage || '';

    this.form = new FormGroup({
      unit: new FormControl('', {
        validators: [
          Validators.required,
          Validators.maxLength(10),
          Validators.pattern('^[A-Za-z0-9]+$')
        ]
      }),
      factor: new FormControl('', {
        validators: [
          Validators.required,
          Validators.maxLength(10),
          Validators.pattern('^[0-9]+([,.][0-9]+)?$')
        ]
      })
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onUnitInputChange(): void {
    const value = this.form.get('unit')?.value || '';
    const upperCaseValue = value.toUpperCase();
    if (value !== upperCaseValue) {
      this.form.get('unit')?.setValue(upperCaseValue, { emitEvent: false });
    }
  }

  onAddClick(): void {
    if (this.form.valid && this.onAddCallback) {
      const unit = this.form.get('unit')?.value.trim();
      const factorStr = this.form.get('factor')?.value.replace(',', '.');
      const factorNumber = parseFloat(factorStr);
      this.onAddCallback(unit, factorNumber);
    }
  }

  isFormValid(): boolean {
    return this.form.valid;
  }
}

